import { combineReducers } from 'redux'
import {
  createReducer,
  createNamedReducer
} from 'helpers/ReducerUtil'

import {
  FETCH_REPORT_START,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_ERROR,
  UPDATE_REPORT,
  REMOVE_REPORT,
  ON_SELECT_FILTER,
  ON_UNSELECT_FILTER,
  CLEAR_REPORTS,
  UPDATE_QUERY_SOURCE,
  UPDATE_QUERY,
  UPDATE_QUERY_CHANGES,
  UPDATE_BAR_RANGE,
  CLEAR_BAR_RANGE,
  CLEAR_CHART_STATE,
  ON_SELECT_MAX_THERMAL,
  ON_SELECT_AVG_THERMAL,
  ON_CLEAR_MAX_THERMAL,
  ON_CLEAR_AVG_THERMAL,
  ON_TOGGLE_MAX_THERMAL,
  ON_TOGGLE_AVG_THERMAL,
  UPDATE_SELECTED_POINT_THERMAL,
  ON_CHART_TABLE_LOADING_START,
  ON_CHART_TABLE_LOADING_END,
  queryEnum,
  thermalCharts,
  histogramCharts
} from './constants'

const updateSource = (prev, { source }) => source

const updateQuery = (prev, { query }) => query

const updateChanges = (prev, { changes }) => changes

const updateReport = (prev, { report }) => {
  let newState = []
  newState = prev.filter(prevReport => report.type !== prevReport.type)
  newState.push(report)
  return newState
}

const removeReport = (prev, { report }) => {
  const newState = [...prev]
  const index = newState.findIndex(prevReport => report === prevReport.type)
  if (index !== -1) {
    newState.splice(index, 1)
  } 
  return newState
}

const querySourceReducer = createReducer([], {
  [UPDATE_QUERY_SOURCE]: updateSource,
})

const queryReducer = createReducer([], {
  [UPDATE_QUERY]: updateQuery,
})

const queryChangesReducer = createReducer([], {
  [UPDATE_QUERY_CHANGES]: updateChanges,
})

const clearReports = () => []

const selectFilter = (prev, { report }) => [...prev, report]

const unselectFilter = (prev, { report }) => {
  const newState = [...prev]
  const index = newState.findIndex(prevReport => report === prevReport)
  if (index !== -1) {
      newState.splice(index, 1)
    } 
  return newState
}

const queryBuilder = () => {
  const reducers = Object.keys(queryEnum)
    .reduce((result, key) => {
      const name = queryEnum[key].value
      const reducer = combineReducers({
        source: createNamedReducer(name, querySourceReducer),
        query: createNamedReducer(name, queryReducer),
        input: createNamedReducer(name, queryChangesReducer)
      })
      return {
        ...result,
        [name]: reducer
      }
    }, {})
  return combineReducers(reducers)
}

const selectedXStartReducer = createReducer(null, {
  [UPDATE_BAR_RANGE]: (prev, {start}) => start == null ? prev : start,
  [CLEAR_BAR_RANGE]: () => null,
  [CLEAR_CHART_STATE]: () => null
})

const selectedXEndReducer = createReducer(null, {
  [UPDATE_BAR_RANGE]: (prev, {end}) => end == null ? prev : end,
  [CLEAR_BAR_RANGE]: () => null,
  [CLEAR_CHART_STATE]: () => null
})

const thermalChartMaxReducer = createReducer(true, {
  [ON_SELECT_MAX_THERMAL]: () => true,
  [ON_CLEAR_MAX_THERMAL]: () => false,
  [ON_TOGGLE_MAX_THERMAL]: (prev) => !prev,
  [ON_TOGGLE_AVG_THERMAL]: () => false
})

const thermalChartAvgReducer = createReducer(false, {
  [ON_SELECT_AVG_THERMAL]: () => true,
  [ON_CLEAR_AVG_THERMAL]: () => false,
  [ON_TOGGLE_AVG_THERMAL]: (prev) => !prev,
  [ON_TOGGLE_MAX_THERMAL]: () => false
})

const thermalSelectedPointReducer = createReducer(null, {
  [UPDATE_SELECTED_POINT_THERMAL]: (prev, { projectId }) => projectId == null ? prev : projectId,
  [CLEAR_CHART_STATE]: () => null
})

const tableLoadingReducer = createReducer (false, {
  [UPDATE_BAR_RANGE]: () => true,
  [UPDATE_SELECTED_POINT_THERMAL]: () => true,
  [ON_CHART_TABLE_LOADING_START]: () => true,
  [ON_CHART_TABLE_LOADING_END]: () => false,
})

const chartLoadingReducer = createReducer (false, {
  [FETCH_REPORT_START]: () => true,
  [FETCH_REPORT_SUCCESS]: () => false,
  [FETCH_REPORT_ERROR]: () => false,
})

const chartStateBuilder = () => {
  return combineReducers({
    ...Object.assign(...histogramCharts.map(chart => ({
      [chart.value]: combineReducers({
        selectedXStart: createNamedReducer(chart.value, selectedXStartReducer),
        selectedXEnd: createNamedReducer(chart.value, selectedXEndReducer),
        tableLoading: createNamedReducer(chart.value, tableLoadingReducer),
        chartLoading: createNamedReducer(chart.value, chartLoadingReducer),
      })
    }))),
    ...Object.assign(...thermalCharts.map(chart => ({
      [chart.value]: combineReducers({
        max: createNamedReducer(chart.value, thermalChartMaxReducer),
        avg: createNamedReducer(chart.value, thermalChartAvgReducer),
        selectedPoint: createNamedReducer(chart.value, thermalSelectedPointReducer),
        tableLoading: createNamedReducer(chart.value, tableLoadingReducer),
        chartLoading: createNamedReducer(chart.value, chartLoadingReducer),
      })
    })))
  })
}

const reports = createReducer([], {
  [UPDATE_REPORT]: updateReport,
  [REMOVE_REPORT]: removeReport,
  [CLEAR_REPORTS]: clearReports
})

const filters = createReducer([], {
  [ON_UNSELECT_FILTER]: unselectFilter,
  [ON_SELECT_FILTER]: selectFilter,
})

const isLoading = createReducer(false, {
  [FETCH_REPORT_START]: () => true,
  [FETCH_REPORT_SUCCESS]: () => false,
  [FETCH_REPORT_ERROR]: () => false,
})

export default combineReducers({
  reports,
  filters,
  query: queryBuilder(),
  chartState: chartStateBuilder(),
  isLoading,
})
